<template>
  <div>
    <legend>Отчет №5</legend>

    <div class="form-group row mx-auto sticky-top py-3 bg-white" style="max-width: 600px">
      <div class="col">
        <date-picker v-model="from" :first-day-of-week="1" :input-attr="{required: true}"
                     class="w-100"
                     input-class="form-control"
                     lang="ru"
                     placeholder="С" valueType="format">
        </date-picker>
      </div>
      <!--      <div class="col">-->
      <!--        <date-picker v-model="to" :first-day-of-week="1" :input-attr="{required: true}"-->
      <!--                     class="w-100"-->
      <!--                     input-class="form-control"-->
      <!--                     lang="ru"-->
      <!--                     placeholder="По" valueType="format">-->
      <!--        </date-picker>-->
      <!--      </div>-->
      <div class="col">
        <button class="btn btn-outline-info" @click="setPrevWeek">Назад</button>
        <button class="ml-3 btn btn-outline-info" @click="setNextWeek">Вперед</button>
      </div>
    </div>
    <div class="overflow-auto stats4-table-wrapper">
      <transition name="fade">
        <table v-if="isLoadedSummaries"
               class="stats5-table-wrapper table table-bordered table-sm text-center small table-hover">
          <thead>
          <tr>
            <th rowspan="2">Отчетная дата</th>
            <th rowspan="2">Категория</th>
            <th colspan="5">Не доставлено</th>
            <th colspan="2">Доставлено</th>
            <template v-for="pt in report.paymentTypes">
              <th colspan="2">Оплачено, {{ pt.Name }}</th>
            </template>
            <th colspan="2">Оплачено долгов, Н</th>
            <th colspan="2">Оплачено долгов, БН</th>
            <th colspan="2">Оплачено долгов, ЧК</th>
            <th colspan="2">Оплачено долгов, НС</th>
            <th colspan="5">Долг (доставлено - не оплачено)</th>
            <th rowspan="2">Расходы</th>
            <!--              <th rowspan="2">Расход - Отправлено</th>-->
            <th rowspan="2">Отправлено</th>
            <th rowspan="2">Отправлено "карта"</th>
            <th rowspan="2">В кассе (всего)</th>
            <th rowspan="2">В кассе (на руках)</th>
            <th rowspan="2">На карте</th>
            <th rowspan="2">Оплата на карту</th>
          </tr>
          <tr>
            <th>Кол-во (шт.)</th>
            <th>Н, руб.</th>
            <th>БН, руб.</th>
            <th>ЧК, руб.</th>
            <th>НС, руб.</th>

            <th>Кол-во (шт.)</th>
            <th>Сумма руб.</th>
            <th>Кол-во (шт.)</th>
            <th>Сумма руб.</th>
            <th>Кол-во (шт.)</th>
            <th>Сумма руб.</th>
            <th>Кол-во (шт.)</th>
            <th>Сумма руб.</th>
            <th>Кол-во (шт.)</th>
            <th>Сумма руб.</th>
            <th>Кол-во (шт.)</th>
            <th>Сумма руб.</th>
            <th>Кол-во (шт.)</th>
            <th>Сумма руб.</th>
            <th>Кол-во (шт.)</th>
            <th>Сумма руб.</th>
            <th>Кол-во (шт.)</th>
            <th>Сумма руб.</th>

            <th>Кол-во (шт.)</th>
            <th>Н, руб.</th>
            <th>БН, руб.</th>
            <th>ЧК, руб.</th>
            <th>НС, руб.</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td rowspan="10" style="white-space: nowrap">
              {{ from }}
            </td>
          </tr>
          <tr v-for="cc in report.customerCategories">
            <td>{{ cc.Name }}</td>
            <td>
              <a href="#" @click.prevent="paidOrdersModal('notInDelivery', from, cc.Id)">
                {{ sumOrderItemAmountByCcId(report.orderItemsNotInDeliveryResult, cc.Id) }}
              </a>
            </td>
            <template v-for="pt in report.paymentTypes">
              <td>{{ sumOrderItemSummaryByCcIdAndPtId(report.orderItemsNotInDeliveryResult, cc.Id, pt.Id) }}</td>
            </template>
            <td>
              <a href="#" @click.prevent="paidOrdersModal('delivered', from, cc.Id)">
                {{ findOneOrderItemAmountByCcId(report.orderItemsDeliveredResult, cc.Id) }}
              </a>
            </td>
            <td>{{ findOneOrderItemSummaryByCcId(report.orderItemsDeliveredResult, cc.Id) }}</td>
            <template v-for="pt in report.paymentTypes">
              <td>
                <a href="#" @click.prevent="paidOrdersModal('paid', from, cc.Id, pt.Id)">
                  {{ findAmountAndSummaryByCcIdAndPtId(report.orderItemsPaidResult, cc.Id, pt.Id).OrderItemAmount }}
                </a>
              </td>
              <td>
                {{ findAmountAndSummaryByCcIdAndPtId(report.orderItemsPaidResult, cc.Id, pt.Id).OrderItemSummary }}
              </td>
            </template>
            <template v-for="pt in report.paymentTypes">
              <td>
                <a href="#" @click.prevent="paidOrdersModal('debtPaid', from, cc.Id, pt.Id)">
                  {{ findAmountAndSummaryByCcIdAndPtId(report.orderItemsDebtPaidResult, cc.Id, pt.Id).OrderItemAmount }}
                </a>
              </td>
              <td>
                {{
                  findAmountAndSummaryByCcIdAndPtId(report.orderItemsDebtPaidResult, cc.Id, pt.Id).OrderItemSummary
                }}
              </td>
            </template>
            <td>
              <a href="#" @click.prevent="paidOrdersModal('debtInDelivery', from, cc.Id)">
                {{ sumOrderItemAmountByCcId(report.orderItemsDebtInDeliveryResult, cc.Id) }}
              </a>
            </td>
            <template v-for="pt in report.paymentTypes">
              <td>
                <a href="#" @click.prevent="paidOrdersModal('debtInDelivery', from, cc.Id, pt.Id)">
                  {{ sumOrderItemSummaryByCcIdAndPtId(report.orderItemsDebtInDeliveryResult, cc.Id, pt.Id) }}
                </a>
              </td>
            </template>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>{{ report.cardPassed[cc.Id] }}</td>
          </tr>

          <tr>
            <td>Итого</td>
            <td>
              <a href="#" @click.prevent="paidOrdersModal('notInDelivery', from)">
                {{ sumOrderItemAmount(report.orderItemsNotInDeliveryResult) }}
              </a>
            </td>
            <template v-for="pt in report.paymentTypes">
              <td>
                {{ sumOrderItemSummaryByPtId(report.orderItemsNotInDeliveryResult, pt.Id) }}
              </td>
            </template>
            <td>
              <a href="#" @click.prevent="paidOrdersModal('delivered', from)">
                {{ sumOrderItemAmount(report.orderItemsDeliveredResult) }}
              </a>
            </td>
            <td>{{ sumOrderItemSummary(report.orderItemsDeliveredResult) }}</td>
            <template v-for="pt in report.paymentTypes">
              <td>
                <a href="#" @click.prevent="paidOrdersModal('paid', from, null, pt.Id)">
                  {{ sumOrderItemAmountByPtId(report.orderItemsPaidResult, pt.Id) }}
                </a>
              </td>
              <td>
                {{ sumOrderItemSummaryByPtId(report.orderItemsPaidResult, pt.Id) }}
              </td>
            </template>
            <template v-for="pt in report.paymentTypes">
              <td>
                <a href="#" @click.prevent="paidOrdersModal('debtPaid', from, null, pt.Id)">
                  {{ sumOrderItemAmountByPtId(report.orderItemsDebtPaidResult, pt.Id) }}
                </a>
              </td>
              <td>
                {{ sumOrderItemSummaryByPtId(report.orderItemsDebtPaidResult, pt.Id) }}
              </td>
            </template>
            <td>
              <a href="#" @click.prevent="paidOrdersModal('debtInDelivery', from, null, null)">
                {{ sumOrderItemAmount(report.orderItemsDebtInDeliveryResult) }}
              </a>

            </td>
            <template v-for="pt in report.paymentTypes">
              <td>
                <a href="#" @click.prevent="paidOrdersModal('debtInDelivery', from, null, pt.Id)">
                  {{ sumOrderItemSummaryByPtId(report.orderItemsDebtInDeliveryResult, pt.Id) }}
                </a>
              </td>
            </template>
            <!--              <td>{{ report.expensesOutByDate }}</td>-->
            <td>{{ report.outMinusInByDay }}</td>
            <td>{{ report.inToMain }}</td>
            <td>{{ report.inToMainCard }}</td>
            <td>{{ report.totalSumCash }}</td>
            <td>{{ report.totalSumCashWithoutCard }}</td>
            <td>{{ report.card }}</td>
            <td>
              <a href="#" @click.prevent="paidOrdersModal('card', from, null, null)">
                {{ report.cardPassedSum }}
              </a>
            </td>
          </tr>
          </tbody>
        </table>
      </transition>
    </div>
    <modals-container></modals-container>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import _ from 'lodash';
import { get } from '@/admin/services/api/http-utils';
import $ from 'jquery';
import PaidOrders from '@/admin/components/modals/stats5/PaidOrders';
import ErrorModal from '@/admin/components/ErrorModal';

const today = moment();
// const today1 = moment();
// const fromDate = today.startOf('week').subtract(135, 'days').day(1);
const fromDate = today;
// const toDate = today1.endOf('week').day(7);

export default {
  components: {
    DatePicker,
    PaidOrders,
  },
  data() {
    return {
      fromMaster: fromDate,
      // toMaster: toDate,
      report: {},
      isLoaded: false,
      isLoadedSummaries: false,
    };
  },
  async mounted() {
    await this.fetchReport();
  },
  watch: {
    async from() {
      this.isLoadedSummaries = false;
      await this.fetchReport();
    },
    isLoadedSummaries: _.debounce((newVal) => {
      const $stats5TableWrapper = $('.stats5-table-wrapper');
      const height = $stats5TableWrapper.outerHeight();
      if (newVal) {
        $stats5TableWrapper.css({ height: 'auto' });
      } else {
        $stats5TableWrapper.css({ height });
      }
    }, 250),
  },
  computed: {
    from: {
      get() {
        return this.fromMaster.format('YYYY-MM-DD');
      },
      set(val) {
        if (!val) {
          this.fromMaster = fromDate;
        } else {
          this.fromMaster = moment(val);
        }
      },
    },
    // to: {
    //   get() {
    //     return this.toMaster.format('YYYY-MM-DD');
    //   },
    //   set(val) {
    //     if (!val) {
    //       this.toMaster = toDate;
    //     } else {
    //       this.toMaster = moment(val);
    //     }
    //   },
    // },
    // summaries() {
    //
    // },
  },
  methods: {
    paidOrdersModal(title, day, ccId, ptId) {
      this.$modal.show(PaidOrders, {
        title, day, ccId, ptId,
      }, {
        width: '98%',
        height: '98%',
        // pivotY: 0.2,
        adaptive: true,
      });
    },
    sumOrderItemAmount(data) {
      return _.sumBy(data, o => parseInt(o.OrderItemAmount));
    },
    sumOrderItemSummary(data) {
      return _.sumBy(data, o => parseInt(o.OrderItemSummary));
    },
    sumOrderItemSummaryByPtId(data, ptId) {
      // console.log(data, ptId)
      const items = _.filter(data, { PaymentTypeId: ptId });
      return _.sumBy(items, o => parseInt(o.OrderItemSummary));
    },
    sumOrderItemAmountByPtId(data, ptId) {
      const items = _.filter(data, { PaymentTypeId: ptId });
      return _.sumBy(items, o => parseInt(o.OrderItemAmount));
    },
    sumOrderItemSummaryByCcIdAndPtId(data, ccId, ptId) {
      const val = _.find(data, { CustomerCategoryId: ccId, PaymentTypeId: ptId });
      return val && val.OrderItemSummary ? val.OrderItemSummary : '';
    },
    sumOrderItemAmountByCcId(data, ccId) {
      const items = _.filter(data, { CustomerCategoryId: ccId });
      const val = _.sumBy(items, 'OrderItemAmount');
      return val || '';
    },
    findOneOrderItemAmountByCcId(data, ccId) {
      const val = _.find(data, { CustomerCategoryId: ccId });
      return val && val.OrderItemAmount ? val.OrderItemAmount : '';
    },
    findOneOrderItemSummaryByCcId(data, ccId) {
      const val = _.find(data, { CustomerCategoryId: ccId });
      return val && val.OrderItemSummary ? val.OrderItemSummary : '';
    },
    findAmountAndSummaryByCcIdAndPtId(data, ccId, ptId) {
      const rr = _.filter(data, { CustomerCategoryId: (+ccId), PaymentTypeId: (+ptId) });
      const OrderItemAmount = _.sumBy(rr, o => +o.OrderItemAmount);
      const OrderItemSummary = _.sumBy(rr, o => +o.OrderItemSummary);
      return {
        OrderItemAmount: OrderItemAmount || '',
        OrderItemSummary: OrderItemSummary || '',
      };
    },
    setNextWeek() {
      this.fromMaster = moment(this.fromMaster).add(1, 'days');
      this.toMaster = moment(this.toMaster).add(1, 'days');
    },
    setPrevWeek() {
      this.fromMaster = moment(this.fromMaster).subtract(1, 'days');
      this.toMaster = moment(this.toMaster).subtract(1, 'days');
    },
    fetchReport: _.debounce(async function qqq() {
      const { data } = await get(`/admin/stats/stats5/${this.from}`);
      this.report = data;
      this.isLoadedSummaries = true;
    }, 250),
  },
};
</script>
<style lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
  opacity: 0;
}

.v--modal-overlay {
  z-index: 2000;
}

//table.stats5-table-wrapper {
//  table {
//    tbody {
//      tr {
//        td {
//
//        }
//      }
//    }
//  }
//}
</style>
